<template>
	<modal class="integration-modal" size="medium" @close="close">
		<template slot="header">
			<h3>Empty Default Shipping Address</h3>
		</template>
		<template slot="body">
			<div class="text-bold">Alamat Pengiriman Default Anda kosong.</div>
			<div v-if="isOwner">Mohon isi terlebih dahulu di Menu Settings &#8594; Store Information &#8594; Default
				Shipping. Atau klik tombol <b>Go To Settings</b> di bawah.</div>
			<div v-else>Minta Store Owner untuk mengisi Alamat Pengiriman Default di Menu Settings &#8594; Store Information
				&#8594; Default Shipping.</div>
		</template>
		<template slot="footer">
			<button type="button" class="btn btn-default" @click="close">
				{{ $t('Cancel') }}
			</button>
			<button type="button" class="btn btn-primary" v-if="isOwner" @click="goToStoreSettings">
				{{ $t('Go To Settings') }}
			</button>
		</template>
	</modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
	name: 'StoreAddressAlertModal',
	components: {
		Modal,
	},
	methods: {
		close() {
			this.$emit('close');
		},
		goToStoreSettings() {
			this.$router.push('settings/store#shipping');
		},
	},
	computed: {
		...mapGetters({
			isOwner: 'isOwner',
		}),
	},
};
</script>
